<template>
    <article>
        <p>
            Coroot's Role-Based Access Control (RBAC) feature allows teams to manage user permissions by assigning roles
            with specific access levels. This ensures that users only have access to the data and features relevant to their role,
            enhancing security and simplifying access management.
            RBAC helps maintain control over sensitive information while allowing seamless collaboration across the team.
        </p>

        <p>
            Coroot's Community Edition includes three predefined roles: Admin, Editor, and Viewer, each with specific access levels.
            Admins have full control, Editors can make changes, and Viewers have read-only access.
            The permission sets for these roles are fixed and cannot be customized:
        </p>

        <v-card max-width="1200">
            <v-img eager src="/static/img/docs/coroot/rbac_ce.png" />
        </v-card>

        <h2>Granular Role-Based Access Control (RBAC)</h2>

        <v-alert color="info" outlined text class="mt-5">
            Granular Role-Based Access Control (RBAC) is available only in Coroot Enterprise (from $1 per CPU core/month).
            <a href="https://coroot.com/account" target="_blank" class="font-weight-bold">Start</a> your free trial today.
        </v-alert>

        <p>
            To manage Coroot roles, go to the project settings (<v-icon small>mdi-cog</v-icon>), click on Organization:
        </p>

        <v-card max-width="1200">
            <v-img eager src="/static/img/docs/coroot/rbac_ee.png" />
        </v-card>

        <p>
            To add a new role, click "Add role" and configure the permission policies.
        </p>

        <p>
            For instance, you can grant full access to a project, or restrict access to viewing only specific applications
            within a particular category or even limit it to a specific application, providing fine-grained control over user permissions.
        </p>

        <v-card max-width="800">
            <v-img eager src="/static/img/docs/coroot/rbac_ee_custom_role.png" />
        </v-card>










    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
